import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./Opportunities.css";
import "./AdvisoryPartnerForm/AdvisoryPartnerForm.css"
import "./BusinessPartnerForm/BusinessPartnerForm.css"
import "./DeliveryPartnerForm/DeliveryPartnerForm.css"
import "./EmployeePartnerForm/EmployeePartnerForm.css"

const sidebarLinks = [
  { label: "Advisory Partner",           path: "/insights/advisory-partner" },
  { label: "Delivery Partner",           path: "/insights/delivery-partner" },
  { label: "Business Partner",           path: "/insights/business-partner" },
  { label: "Employee Partner",           path: "/insights/employee-partner" },
];

export default function Opportunities() {
  const location = useLocation();
  const isRoot =
    location.pathname === "/insights" || location.pathname === "/insights/";

  // Scroll to top when location changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // or "instant" for immediate scroll
    });
  }, [location.pathname]);

  return (
    <div className="about-layout">
      {/* ── Sidebar ── */}
      <aside className="about-sidebar">
        <p className="about-sidebar__heading">Opportunities</p>
        <nav className="about-sidebar__nav">
          {sidebarLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                isActive
                  ? "about-sidebar__link about-sidebar__link--active"
                  : "about-sidebar__link"
              }
            >
              <span className="about-sidebar__dot" />
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* ── Main content ── */}
      <main className="Opp-main">
        {isRoot ? <Navigate to="/insights/advisory-partner" replace /> : <Outlet />}
      </main>
    </div>
  );
}